module.exports = "./img/c6da5a429f392dd9e8530beccaffb862.png";